import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import cx from 'classnames';
import {mtLogo} from './styles.scss';

const Partnerships = ({source, width, height, isTrackHeader}) => {
  return (
    <div
      className={cx({
        flex: isTrackHeader,
      })}
    >
      <p
        className={cx({
          [mtLogo]: isTrackHeader,
        })}
      >
        <FormattedMessage id="partnership_with" />
      </p>
      <div
        className={cx({
          tc: !isTrackHeader,
        })}
      >
        <a
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="https://www.digitalocean.com/"
          className={cx('link pointer', {
            ph2: isTrackHeader,
          })}
          title="Digital ocean"
        >
          <img src={source} alt="Digital-ocean" width={width} height={height} />
        </a>
      </div>
    </div>
  );
};

Partnerships.propTypes = {
  source: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  isTrackHeader: PropTypes.bool,
};

export default Partnerships;
